import { defaultFont } from "assets/jss/material-dashboard-react.js";

const tableStyle = () => ({
  warningTableHeader: { color: "#f59e0b" },
  primaryTableHeader: { color: "#1a73e8" },
  dangerTableHeader: { color: "#ef4444" },
  successTableHeader: { color: "#22c55e" },
  infoTableHeader: { color: "#0288d1" },
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse",
  },
  tableHeadCell: {
    color: "#a0aec0",
    fontFamily: '"Inter", "Roboto", sans-serif',
    fontSize: "12px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    padding: "12px 16px",
    borderBottom: "1px solid #f0f4f8",
    lineHeight: "1.5",
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.5",
    padding: "13px 16px",
    verticalAlign: "middle",
    fontSize: "14px",
    color: "#2d3748",
    borderBottom: "1px solid #f7f9fc",
    borderTop: "none",
  },
  tableResponsive: {
    width: "100%",
    marginTop: "0",
    overflowX: "auto",
    borderRadius: "8px",
    background: "#ffffff",
    border: "1px solid #e8eef7",
  },
  tableHeadRow: {
    height: "56px",
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle",
  },
  tableBodyRow: {
    height: "48px",
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle",
    transition: "background 0.15s",
    "&:hover": {
      background: "#f8faff",
    },
  },
});

export default tableStyle;
